/**
 * Created by pzf on 18/9/1.
 *
 */
export default function noop() {}
//# sourceMappingURL=noop.js.map
